import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import CandidateLayout from '../components/CandidateLayout';
import SharedMessages from '../../shared/messages/pages/Messages';
import { useAuthProtection } from '../hooks/useAuthProtection';

/**
 * Candidate Messages Page
 * Uses same layout structure as Dashboard page (CandidateSidebar + inline header)
 * Protected Route: Only accessible to authenticated candidates
 */
const Messages: React.FC = () => {
  // Protect route - redirect to login if not authenticated
  useAuthProtection();

  const [searchParams] = useSearchParams();
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userId, setUserId] = useState('');

  // Get application ID from query params (e.g., ?application=123)
  const applicationId = searchParams.get('application');

  // Get user data from localStorage
  useEffect(() => {
    const userDataString = localStorage.getItem('authUser');
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        setUserName(userData.name || userData.email?.split('@')[0] || '');
        setUserEmail(userData.email || '');
        setUserId(userData.id || userData.user_id || userData.candidate_id || '');
      } catch (error) {
        console.error('Failed to parse user data:', error);
      }
    }

    // Log if we have an application ID to auto-open
    if (applicationId) {
      console.log('Candidate Messages - Auto-opening conversation for application:', applicationId);
    }
  }, [applicationId]);

  // User data from localStorage
  const mockUser = {
    id: userId,
    name: userName,
    email: userEmail,
    avatar: undefined,
  };

  return (
    <CandidateLayout
      headerTitle="Messages"
      headerSubtitle="View and manage your conversations with recruiters."
      fullHeight
    >
      {/* Messages Component - fills remaining viewport height below header */}
      <SharedMessages
        userRole="candidate"
        user={mockUser}
        initialConversationId={applicationId || undefined}
      />
    </CandidateLayout>
  );
};

export default Messages;
